import { MessageThreadView, NewMessageView, MessageType } from "daymap-react";
import { PageContainer } from "../../components/layout";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PageHeader from '../../containers/pageheader/pageheader';
import { Alert, Collapse } from "@mui/material";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { AbsentInboudFormChangedArgs, AbsentInboundForm } from "./components/AbsentInboundForm";

export default function MessageThread() {
    const { messageId } = useParams();
    const navigate = useNavigate();

    return <>
        <PageHeader title="Message" onBackButtonClick={() => navigate(-1)} />
        <MessageThreadView 
            messageId={Number(messageId)}
            onMessageClick={(id) => navigate(`/message/${id}`)}
            onMessageSent={(message) => navigate(`/message/${message.MessageID}`)}
            pageContainer={PageContainer}
        />
    </>
}

type CheckType = "NO_STUDENT_SELECTED"

export function NewMessage() {
    const navigate = useNavigate();
    const { messageType } = useParams();
    const [messageProps, setMessageProps] = useState<{[key:string]:any}>({})
    const [alertMessage, setAlertMessage] = useState<[CheckType, string] | null>();
    const [searchParams] = useSearchParams();
    const [initialRecipients, setInitialRecipients] = useState<number[]>([]);
    
    //Load initial props for absence messages and recipients
    useEffect(() =>{
        // Check for contactid parameter for pre-selecting recipient
        const contactIdParam = searchParams.get('contactid');
        const contactId = Number(contactIdParam);
        if (contactIdParam && !isNaN(contactId) && contactId > 0) {
            setInitialRecipients([contactId]);
        } else {
            setInitialRecipients([]);
        }

        if(Number(messageType) === MessageType.AbsenceInbound) {
            let startDate = new Date();
            const startStudentIds: number[] = [];

            if (searchParams.has('student'))
                startStudentIds.push(Number(decodeURI(searchParams.get("student")!)));

            if (searchParams.has('date')) {
                const paramDate = decodeURI(searchParams.get("date")!);
                if (dayjs(paramDate).isValid())
                    startDate = dayjs(paramDate).toDate();
            } 
            
            absencePropsChanged({ date: startDate, reason: "", studentIds: startStudentIds });
        }
    },[messageType, searchParams])

    const absencePropsChanged = ({date, reason, studentIds}:AbsentInboudFormChangedArgs) => {
        console.log(studentIds);
        const newProps: any = {};
        newProps.AbsentStudent = studentIds.length > 0 ? studentIds.join(',') : null;

        if (studentIds.length > 0 && alertMessage && alertMessage[0] === "NO_STUDENT_SELECTED")
            setAlertMessage(null);

        if (date)
            newProps.AbsenceDate = dayjs(date).format('YYYY-MM-DD');

        if (reason)
            newProps.AbsenceReason = reason;

        setMessageProps(newProps);
    }

    const canSendCheck = () => {
        if (Number(messageType) === MessageType.AbsenceInbound && !messageProps.AbsentStudent) {
            setAlertMessage(['NO_STUDENT_SELECTED', 'Must select a student']);
            return false;
        }

        return true;
    }

    let absenceDate:Date = new Date();
    if (messageProps.AbsenceDate && dayjs(messageProps.AbsenceDate, "YYYY-MM-DD").isValid())
        absenceDate = dayjs(messageProps.AbsenceDate, "YYYY-MM-DD").toDate();

    const absenceContent = Number(messageType) === MessageType.AbsenceInbound ? (
        <>
            <AbsentInboundForm 
                date={absenceDate} 
                reason={messageProps.AbsenceReason} 
                students={messageProps.AbsentStudent?.split(",").map((x:string) => Number(x))} 
                onChange={absencePropsChanged} 
            />
            {alertMessage && <Collapse in={Boolean(alertMessage)}>
                <Alert severity="error">
                    {alertMessage[1]}
                </Alert>
            </Collapse>}
        </>
    ) : undefined;

    return <>
        <PageHeader title="New Message" onBackButtonClick={() => navigate(-1)} />
        <NewMessageView 
            messageType={Number(messageType)}
            onMessageSent={(message) => navigate(`/message/${message.MessageID}`)}
            messageProperties={messageProps}
            initialRecipients={initialRecipients}
            pageContainer={PageContainer}
            additionalContent={absenceContent}
            additionalValidation={canSendCheck}
        />
    </>
}